import React from 'react'
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Typography,
} from '@mui/material'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import { WhiteOutlineCheckbox } from '../Support/CustomElements'
import { useStyles } from '../../style/views'

const CATEGORIES = [
    '---',
    'Journal Pub',
    'Congress Pub',
    'HCEI 502(a)',
    'PIE',
    'Field Tools',
    'Label',
    'Dossier',
    'Abstract',
    'Poster',
    'Manuscript',
]

const COLUMNS = [
    { id: 'title', label: 'Title' },
    { id: 'type', label: 'Type' },
    { id: 'status', label: 'Status' },
]

interface ActivityDeliverablesFieldProps {
    deliverables: any[]
    onNewDeliverable?: () => void
    onDeliverableChange?: (id: string, field: string, value: any) => void
    onDeliverableDelete?: (id: string) => void
}

const ActivityDeliverablesField: React.FC<ActivityDeliverablesFieldProps> = ({
    deliverables,
    onNewDeliverable,
    onDeliverableChange,
    onDeliverableDelete,
}) => {
    const classes = useStyles()

    return (
        <Grid container item direction="column" spacing={2}>
            <Grid container item direction="column" spacing={2}>
                <Grid item sx={{ mb: -1 }}>
                    <Typography variant="body1" sx={{ fontWeight: 700 }}>
                        Deliverables
                    </Typography>
                </Grid>
                <Grid item>
                    <Button variant="contained" onClick={onNewDeliverable}>
                        New Deliverable
                    </Button>
                </Grid>
            </Grid>
            {deliverables.length > 0 && (
                <Grid item>
                    <TableContainer component={Paper} sx={{ borderRadius: '16px' }}>
                        <Table>
                            <TableHead>
                                {COLUMNS.map((column, i) => (
                                    <TableCell key={column.label + i}>{column.label}</TableCell>
                                ))}
                            </TableHead>
                            <TableBody>
                                {deliverables.map((deliverable, i) => (
                                    <TableRow className={classes.delRows} key={deliverable._id ?? i}>
                                        <TableCell>
                                            <TextField
                                                id={'deliverableTitle' + i}
                                                value={deliverable.title ?? ''}
                                                margin="none"
                                                fullWidth
                                                multiline
                                                style={{ minWidth: '150px' }}
                                                onChange={(e) =>
                                                    onDeliverableChange?.(deliverable._id, 'title', e.target.value)
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <FormControl fullWidth className={`${classes.formControl}`}>
                                                <InputLabel id="pub-type-label">Type</InputLabel>
                                                <Select
                                                    labelId="pub-type"
                                                    id={'pub-type' + i}
                                                    value={deliverable.type ?? ''}
                                                    onChange={(e) =>
                                                        onDeliverableChange?.(deliverable._id, 'type', e.target.value)
                                                    }
                                                    label="Type"
                                                >
                                                    {CATEGORIES.map((x, i) => (
                                                        <MenuItem value={x} key={x + i}>
                                                            {x}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                        <TableCell>
                                            <Grid component="label" container item xs={12} alignItems="center">
                                                <FormControlLabel
                                                    control={
                                                        <WhiteOutlineCheckbox
                                                            checked={deliverable.isComplete ?? false}
                                                            onChange={(e) =>
                                                                onDeliverableChange?.(
                                                                    deliverable._id,
                                                                    'isComplete',
                                                                    e.target.checked
                                                                )
                                                            }
                                                            color="primary"
                                                            name="Completed"
                                                        />
                                                    }
                                                    labelPlacement="bottom"
                                                    label="Completed"
                                                />
                                            </Grid>
                                        </TableCell>
                                        <TableCell>
                                            <DeleteForeverIcon onClick={() => onDeliverableDelete?.(deliverable._id)} />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            )}
        </Grid>
    )
}

export default ActivityDeliverablesField
